<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      edit-title
      unit="留宿报名"
      id-key="StayRegId"
      :data="data"
      form-label-width="90px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名" prop="stNames">
              <el-input size="mini" type="textarea" v-model="data.stNames" readonly @focus="onSTCDialog" placeholder="请选择学生"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="留宿日期" prop="StartDate">
              <el-select v-model="data.StartDate" @change="dateChange">
                <el-option :value="item.StartDate" :label="item.StartDate + ' - ' + item.EndDate" v-for="(item,index) in dateList" :key="index" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年级">
              {{Grade}}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="班级">
              {{data.Class}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="宿舍号">
              {{data.Dormitory}}
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="留宿资格">
              
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本周期量化扣分值">
              
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
    <stc-dialog ref="stcDialog" v-if="showDialog" in-dialog selectable multiple @select-multiple="setSTC" :st-params="stParams" />
  </div>
</template>
<script>
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import stcDialog from "@/components/st/sc/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stcDialog
  },
  data() {
    return {
      api: require("@/api/attendance/reg").default,
      data: {
        StayRegId: 0,
        TermId: loginInfo.TermId,
        stNames: "",
        stIds: [],
        StudentId: 0,
        Class: "",
        ClassId: 0,
        Grade: "",
        Dormitory: "",
        DormitoryId: 0,
        StartDate: "",
        EndDate: "",
        Status: 1,
        Temporary: 0
      },
      showDialog: false,
      pickeds: [],
      dateList: [],
      isMB: this.$store.state.isMB,
      stParams: {
        GradeId: loginInfo.GradeId,
        ClassId: loginInfo.ClassId,
      },
      rules: {
        stNames: [{ required: true, message: "请选择学生" }],
        StartDate: [{ required: true, message: "请选择留宿日期" }],
      },
    };
  },
  computed: {
    Grade() {
      if(this.pickeds.length) {
        return this.pickeds[0].Grade;
      } else return "";
    },
  },
  methods: {
    onCreateOpened() {
      
    },
    onEditOpened() {
    },
    onSTCDialog() {
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.stcDialog.open().then((that) => {
          that.getDataWithClass(loginInfo.TermId, loginInfo.TeacherId, 1);
          that.showForm();
        });
      })
    },
    setSTC(st) {
      this.showDialog = false;
      this.data.stNames = "";
      this.data.stIds = [];
      this.pickeds = [];
      if(st.length == 0) {
        this.dateList = [];
        this.data.StartDate = "";
        this.data.EndDate = "";
        return;
      }
      st.forEach((e,index) => {
        this.data.stIds.push(e.StudentId);
        this.data.stNames += e.FullName;
        this.pickeds.push(e);
        if(st.length > index + 1) {
          this.data.stNames += "，";
        }
      })
      this.getDate();
    },
    getDate() {
      this.api.getStudentStayRegDatesByGradeId(this.pickeds[0].GradeId).then(res => {
        if(res.Code==0) {
          if(res.Data==null) {
            this.dateList = [];
            this.data.StartDate = "";
            this.data.EndDate = "";
            this.$message.warning("暂无留宿日期数据");
            return;
          }
          res.Data.forEach(e => {
            e.StartDate = this.$commonJs.toDateString(e.StartDate);
            e.EndDate = this.$commonJs.toDateString(e.EndDate);
          })
          this.dateList = res.Data;
          if(res.Data.length) {
            this.data.StartDate = res.Data[0].StartDate;
            this.data.EndDate = res.Data[0].EndDate;
          }
        } else {
          this.dateList = [];
          this.data.StartDate = "";
          this.data.EndDate = "";
          this.$message.error(res.Msg);
        }
      })  
    },
    dateChange(v) {
      var obj = this.dateList.find(x => x.StartDate==v);
      this.data.EndDate = obj.EndDate;
    },
    onBeforeSave() {
      var sub = this.pickeds.map(x => {
        return {
          StayRegId: 0,
          TermId: x.TermId,
          ClassId: x.ClassId,
          StudentId: x.StudentId,
          DormitoryId: x.DormitoryId,
          Dormitory: x.Dormitory,
          StartDate: this.data.StartDate,
          EndDate: this.data.EndDate,
          Status: 1,
          Temporary: 0
        }
      })
      // console.log(this.pickeds,sub);
      // return false;
      this.loading(true);
      this.api.insert(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success("保存成功");
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      })
      return false;
    },
    onClosed() {
      this.data.StartDate = "";
      this.dateList = [];
      this.pickeds = [];
    },
  },
};
</script>
<style lang="scss">
</style>